module.exports = __webpack_public_path__ + "static/media/hifi-06.4f30de9c.png";